import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */
  static targets = ["hm0_output"];

  connect() {
    console.log("Intervention JS en cours ...");
    super.connect();
    if (
      $("#partial-factures_clients-content").length &&
      $("#partial-factures_clients-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      //on est sur le show
      setTimeout(() => this.factures_clients_hm_ajax(), 300);
    }
    if (
      $("#partial-frais-content").length &&
      $("#partial-frais-content")
        .text()
        .search(/Chargement en cours/i) > -1
    ) {
      //on est sur le show
      setTimeout(() => this.frais_hm_ajax(), 300);
    }
    // add your code here, if applicable
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
      $("#filterrific_with_entreprise_raison_sociale").on("input", function () {
        $("#target_entreprise_raison_sociale").val(
          $("#filterrific_with_entreprise_raison_sociale").val()
        );
      });

      var targetElement = document.getElementById("mySidebar");
      targetElement.addEventListener("scroll", (event) => {
        var element = document.getElementById("mySidebar");
        console.log(
          "From intervention_controller.js =======> ",
          element.scrollTop
        );
        document.getElementById("scrollevel").value = element.scrollTop;
      });
    }
  }

  afterShowInterventions(event) {
    $("#dates_form_submit").click();
  }

  factures_clients_hm_ajax() {
        if (this.current_app && this.intervention_id) {
            let url =
                window.location.origin +
                "/" +
                this.current_app +
                "/interventions/show_ajax_for_hm_factures_clients?intervention_id=" +
                this.intervention_id +
                "&vr2=1";
                console.log(url);
            fetch(url).then((response) =>
                response.text().then(function (text) {
                    $("#partial-factures_clients-content").html("");
                    $("#partial-factures_clients-content").html(text);
                })
            );
        }
    }

  frais_hm_ajax() {
    if (this.current_app && this.intervention_id) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/interventions/show_ajax_for_hm_frais?intervention_id=" +
        this.intervention_id +
        "&vr2=1";
      console.log(url);
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-frais-content").html("");
          $("#partial-frais-content").html(text);
        })
      );
    }
  }



  update_hmfs() {
    var table = document.getElementById("hmf_prestations");
    // Check if the table element exists
    if (table) {
      // Get all input elements with id "_prix" inside the table
      var inputElements = table.querySelectorAll("input[id*='_prix']");

      // Loop through the input elements and do something
      for (var i = 0; i < inputElements.length; i++) {
        var inputElement = inputElements[i];
        // Do something with the input element, for example, log its value
        if (parseFloat(inputElement.value) > 0) {
          inputElement.dispatchEvent(new Event("change"));
        }
      }
    }
  }

  get current_app() {
    return this.data.get("app");
  }

  get params() {
    return this.data.get("params");
  }

  get intervention_id() {
    return this.data.get("interventionid");
  }

  get url_solution() {
    return this.data.get("urlsolution");
  }
}
